module.exports = __webpack_public_path__ + "assets/img/5.dc1de697.png";